import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getAssociationLinkOptions = get('guest.associationLinkOptions');

export const getAll = createSelector(getAssociationLinkOptions, get('all'));

export const getMeta = createSelector(getAssociationLinkOptions, get('meta'));

export const getFetching = createSelector(
  getAssociationLinkOptions,
  get('fetching')
);

export const getFetched = createSelector(
  getAssociationLinkOptions,
  get('fetched')
);
